/**
 * Strictly necessary DOM init: lazy images and scheduled visibility.
 * External asset so OtAutoBlock does not block it when functional cookies are rejected.
 */
(function () {
  function loadLazyImage(img) {
    if (!img?.dataset?.lazyImg) return;
    const attr = "srcset" in img.dataset ? "srcset" : "src";
    img.setAttribute(attr, img.dataset.lazyImg);
  }

  function setResponsiveImages(el) {
    if (!el?.dataset?.imgDesktop) return;
    const sources = el.getElementsByTagName("source");
    const images = el.getElementsByTagName("img");
    if (sources[0]) sources[0].setAttribute("srcset", el.dataset.imgDesktop);
    if (images[0]) images[0].src = el.dataset.imgMobile || el.dataset.imgDesktop;
    if (el.dataset.imgTablet && sources[1]) {
      sources[1].setAttribute("srcset", el.dataset.imgTablet);
    }
  }

  function parseScheduleDate(value) {
    if (!value) return null;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  function isScheduledLive(el) {
    const start = parseScheduleDate(el.dataset.start);
    const end = parseScheduleDate(el.dataset.end);
    const now = Date.now();

    if (start && now < start.getTime()) return false;
    if (end && now > end.getTime()) return false;
    if (!start && !end) return true;
    return true;
  }

  function initScheduledElements() {
    document.querySelectorAll("[data-start], [data-end]").forEach((el) => {
      el.setAttribute("data-show-live", isScheduledLive(el) ? "true" : "false");
      if (el.getAttribute("data-show-live") === "true") {
        setResponsiveImages(el);
      }
    });
  }

  function initLazyImages() {
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll("[data-lazy-img]").forEach(loadLazyImage);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            observer.unobserve(entry.target);
            loadLazyImage(entry.target);
          }
        });
      },
      { root: document.body, rootMargin: "100px", threshold: 0.01 }
    );

    document.querySelectorAll("[data-lazy-img]").forEach((img) => observer.observe(img));
  }

  function init() {
    initLazyImages();
    if (window.utils?.timing?.findScheduledElements) {
      const scheduled = document.querySelectorAll("[data-start], [data-end]");
      if (scheduled.length) window.utils.timing.findScheduledElements(scheduled);
    } else {
      initScheduledElements();
    }
    window.__cellcoreNecessaryInit = true;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
